/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import PropTypes from 'prop-types';
import Box from 'ui-box';
import { Row, Typography } from 'antd';
import { ReactComponent as WarningSvg } from '../../../assets/icons/appointment/warning.svg';

const { Title } = Typography

const styles = {
  box: {
    padding: '8px 16px',
    background: '#F5F5F5'
  },
  title: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    color: "#262626",
    margin: 0,
    marginRight: 12
  }
}

const MobileAppointmentEmpty = ({title}) => {
  return (
    <Box style={styles.box}>
      <Row align="middle" justify="center">
        <WarningSvg style={{ marginRight: 12 }}/>
        <Title level={4} style={styles.title}>
          {title}
        </Title>
      </Row>
    </Box>
  )
}

MobileAppointmentEmpty.defaultProps = {
  title: '',
};

const { string } = PropTypes;

MobileAppointmentEmpty.propTypes = {
  title: string,
};

export default MobileAppointmentEmpty;
